import EditionsIcon from '@atlaskit/icon-lab/core/editions';
import * as React from 'react';

export function SvgEditionsIcon() {
  return <EditionsIcon label="editions" />;
}
